import React from 'react';
import PropTypes from 'prop-types';
import PaymentInput from './PaymentInput';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import cCardImage from '../../assets/ccards-accept.png';

function ImageComponent({ src, alt, className }) {
	return <img src={cCardImage} alt={alt} width={160} className={className} />;
}

const SubtotalPanel = (props) => {
	const {
		cartData,
		checkoutInformation,
		handleSubmit,
		handleUpdateForm,
		submitErrors,
		subtotal
	} = props;

	const isDisabled =
		submitErrors?.length ||
		checkoutInformation.cardNumber.length === 0 ||
		checkoutInformation.expirationDate.length === 0 ||
		checkoutInformation.cardCode.length === 0;

	return (
		<Box
			className='filter'
			sx={{
				width: { xs: '100%', sm: '100%', md: '36%', lg: '32%', xl: '40%' },
				border: 1,
				borderColor: 'secondary.main',
				background: (theme) => theme.palette.common.white,
				borderRadius: 2,
				p: 2,
				m: 3,
				mr: 5,
				ml: {
					xs: '0 !important',
					sm: '0 !important',
					md: '56px !important',
					lg: '56px !important',
					xl: '76px !important'
				},
				my: {
					xs: '30px !important',
					sm: '30px !important',
					md: '30px !important',
					lg: '10px !important'
				}
			}}
		>
			<Typography variant='h5' sx={{ mb: 2 }}>
				Your Order
			</Typography>
			<Stack divider={<Divider />} spacing={1}>
				<Stack direction='row' alignItems='center' justifyContent='space-between'>
					<Typography sx={{ fontWeight: 600 }}>Product(s)</Typography>
					<Typography sx={{ fontWeight: 600 }}>Subtotal</Typography>
				</Stack>
				{cartData?.map((giftCard) => {
					return (
						<Stack key={giftCard.id} direction='row' justifyContent='space-between'>
							<Typography sx={{ fontSize: { xs: '0.8rem', md: '1rem' } }}>
								{giftCard?.quantity} &nbsp; ${giftCard?.amount} {giftCard?.company} Gift Card
							</Typography>
							<Typography sx={{ fontSize: { xs: '0.8rem', md: '1rem' } }}>
								${giftCard?.price * giftCard?.quantity}
							</Typography>
						</Stack>
					);
				})}
				<Stack direction='row' justifyContent='space-between'>
					<Typography sx={{ fontWeight: 400, fontSize: { xs: '0.8rem', md: '1rem' } }}>
						Subtotal
					</Typography>
					<Typography sx={{ fontSize: { xs: '0.8rem', md: '1rem' } }}>${subtotal}.00</Typography>
				</Stack>
				<Stack direction='row' justifyContent='space-between'>
					<Typography sx={{ fontWeight: 400, fontSize: { xs: '0.8rem', md: '1rem' } }}>
						Total
					</Typography>
					<Typography sx={{ fontWeight: 400, fontSize: { xs: '0.8rem', md: '1rem' } }}>
						${subtotal}.00
					</Typography>
				</Stack>
			</Stack>
			<Stack mt={5}>
				<Stack direction='row' justifyContent='space-between'>
					<Typography sx={{ fontWeight: 500 }}>Credit card</Typography>
					<ImageComponent alt='Visa, MasterCard, American Express and Discover Credit card logos' />
				</Stack>
				<Typography sx={{ fontWeight: 400, fontSize: '13px' }} mt={1}>
					All transactions are secure and encrypted.
				</Typography>
				<PaymentInput
					checkoutInformation={checkoutInformation}
					handleUpdateForm={handleUpdateForm}
				/>
				<Button
					size='large'
					onClick={handleSubmit}
					disabled={isDisabled}
					sx={{
						mt: 2,
						fontSize: '1.1rem',
						borderRadius: (theme) => theme.pixels.bRadius.main,
						boxShadow: 'none'
					}}
				>
					Place Order
				</Button>
			</Stack>
		</Box>
	);
};

SubtotalPanel.propTypes = {
	cartData: PropTypes.array,
	checkoutInformation: PropTypes.object,
	handleSubmit: PropTypes.func,
	handleUpdateForm: PropTypes.func,
	submitErrors: PropTypes.array,
	subtotal: PropTypes.number
};

export default SubtotalPanel;
